<div class="statistics-table">
  <p-table
    [value]="visibleRows"
    dataKey="key"
    [expandedRowKeys]="expandedRows"
    styleClass="statistics-table__table">

    <ng-template pTemplate="colgroup">
      <colgroup>
        <col class="statistics-table__col-name">
        @for (column of numberColumnIndexes; track column) {
          <col>
        }
      </colgroup>
    </ng-template>

    <ng-template pTemplate="header">
      <tr class="statistics-table__group-row">
        <th></th>
        <th colspan="4" class="statistics-table__group statistics-table__group--start">
          {{ 'statistics.table.groupBalance' | transloco }}
        </th>
        <th [attr.colspan]="columns.length" class="statistics-table__group statistics-table__group--start">
          {{ 'statistics.table.groupLocation' | transloco }}
        </th>
        <th colspan="2" class="statistics-table__group statistics-table__group--start">
          {{ 'statistics.table.groupStockAge' | transloco }}
        </th>
      </tr>
      <tr class="statistics-table__head-row">
        <th>{{ 'statistics.table.category' | transloco }}</th>
        <th class="statistics-table__num statistics-table__num--start">{{ startLabel }}{{ response.year }}</th>
        <th class="statistics-table__num">{{ 'statistics.table.admissions' | transloco }}</th>
        <th class="statistics-table__num">{{ 'statistics.table.departures' | transloco }}</th>
        <th class="statistics-table__num">{{ endLabel }}{{ response.year }}</th>
        @for (column of columns; track column.location; let first = $first) {
          <th class="statistics-table__num" [class.statistics-table__num--start]="first">{{ column.label }}</th>
        }
        <th class="statistics-table__num statistics-table__num--start">
          {{ 'statistics.table.fromPreviousYears' | transloco }}
        </th>
        <th class="statistics-table__num">{{ currentYearLabel }}</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-expanded="expanded">
      <tr
        [pRowToggler]="row"
        class="statistics-table__row"
        [class.statistics-table__row--total]="row.isTotal"
        [class.statistics-table__row--empty]="row.isEmpty && !row.isTotal"
        [class.statistics-table__row--expanded]="expanded">

        <td class="statistics-table__name-cell">
          <i class="pi statistics-table__chevron"
             [class.pi-chevron-right]="!expanded"
             [class.pi-chevron-down]="expanded"></i>
          <span class="statistics-table__name">{{ row.label }}</span>
          @if (row.hint) {
            <span class="statistics-table__hint">{{ row.hint }}</span>
          }
          @if (row.dataQualityCount > 0) {
            <button
              type="button"
              class="statistics-table__badge"
              [pTooltip]="'statistics.table.affectedAnimalsHint' | transloco"
              (click)="$event.stopPropagation(); showDataQuality.emit()">
              {{ 'statistics.table.affectedAnimals' | transloco: {count: row.dataQualityCount} }}
            </button>
          }
        </td>

        <td class="statistics-table__num statistics-table__num--start">
          <span [class.statistics-table__zero]="row.figures.stockAtPeriodStart === 0">
            {{ row.figures.stockAtPeriodStart | statCount }}
          </span>
          @if (compareWithPreviousYear) {
            <span class="statistics-table__delta">{{ delta(row, 'stockAtPeriodStart') }}</span>
          }
        </td>
        <td class="statistics-table__num">
          <span [class.statistics-table__zero]="row.figures.admissions === 0">
            {{ row.figures.admissions | statCount }}
          </span>
          @if (compareWithPreviousYear) {
            <span class="statistics-table__delta">{{ delta(row, 'admissions') }}</span>
          }
        </td>
        <td class="statistics-table__num">
          <span [class.statistics-table__zero]="row.figures.departures === 0">
            {{ row.figures.departures | statCount }}
          </span>
          @if (compareWithPreviousYear) {
            <span class="statistics-table__delta">{{ delta(row, 'departures') }}</span>
          }
        </td>
        <td class="statistics-table__num statistics-table__num--result">
          <span [class.statistics-table__zero]="row.figures.stockAtPeriodEnd === 0">
            {{ row.figures.stockAtPeriodEnd | statCount }}
          </span>
          @if (compareWithPreviousYear) {
            <span class="statistics-table__delta">{{ delta(row, 'stockAtPeriodEnd') }}</span>
          }
        </td>

        @for (count of row.locationCounts; track $index; let first = $first) {
          <td class="statistics-table__num" [class.statistics-table__num--start]="first">
            <span [class.statistics-table__zero]="count === 0">{{ count | statCount }}</span>
          </td>
        }

        <td class="statistics-table__num statistics-table__num--start">
          <span [class.statistics-table__zero]="row.figures.stockBreakdown.fromPreviousYears === 0">
            {{ row.figures.stockBreakdown.fromPreviousYears | statCount }}
          </span>
        </td>
        <td class="statistics-table__num">
          <span [class.statistics-table__zero]="row.figures.stockBreakdown.fromCurrentYear === 0">
            {{ row.figures.stockBreakdown.fromCurrentYear | statCount }}
          </span>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="expandedrow" let-row>
      <tr class="statistics-table__detail-row">
        <td [attr.colspan]="columnCount">
          <div class="statistics-detail">

            <section class="statistics-detail__block">
              <h3>{{ row.breakdownTitle }}</h3>
              <table class="statistics-detail__table">
                <thead>
                <tr>
                  <th>{{ row.breakdownColumn }}</th>
                  <th class="statistics-table__num">{{ startLabel }}</th>
                  <th class="statistics-table__num">{{ 'statistics.table.admissionsShort' | transloco }}</th>
                  <th class="statistics-table__num">{{ 'statistics.table.departuresShort' | transloco }}</th>
                  <th class="statistics-table__num">{{ 'statistics.table.endShort' | transloco }}</th>
                </tr>
                </thead>
                <tbody>
                  @for (entry of row.breakdown; track entry.label) {
                    <tr>
                      <td>{{ entry.label }}</td>
                      <td class="statistics-table__num">
                        <span [class.statistics-table__zero]="entry.figures.stockAtPeriodStart === 0">
                          {{ entry.figures.stockAtPeriodStart | statCount }}
                        </span>
                      </td>
                      <td class="statistics-table__num">
                        <span [class.statistics-table__zero]="entry.figures.admissions === 0">
                          {{ entry.figures.admissions | statCount }}
                        </span>
                      </td>
                      <td class="statistics-table__num">
                        <span [class.statistics-table__zero]="entry.figures.departures === 0">
                          {{ entry.figures.departures | statCount }}
                        </span>
                      </td>
                      <td class="statistics-table__num statistics-table__num--result">
                        <span [class.statistics-table__zero]="entry.figures.stockAtPeriodEnd === 0">
                          {{ entry.figures.stockAtPeriodEnd | statCount }}
                        </span>
                      </td>
                    </tr>
                  } @empty {
                    <tr>
                      <td colspan="5" class="statistics-detail__empty">
                        {{ 'statistics.detail.noBreakdown' | transloco }}
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
              <p class="statistics-detail__note">{{ row.breakdownNote }}</p>
            </section>

            @if (details.get(row.key); as detail) {
              <section class="statistics-detail__block">
                <h3>
                  {{ 'statistics.detail.originTitle' | transloco }}
                  <span class="statistics-detail__subtitle">{{ 'statistics.detail.originSubtitle' | transloco }}</span>
                </h3>
                <ng-container
                  [ngTemplateOutlet]="distribution"
                  [ngTemplateOutletContext]="{items: detail.origins, modifier: 'origin'}">
                </ng-container>
                <div class="statistics-detail__sum">
                  <span>{{ 'statistics.detail.originEvents' | transloco }}</span>
                  <strong>{{ detail.originEvents | statCount }}</strong>
                </div>
                <p class="statistics-detail__note">{{ detail.originNote }}</p>
              </section>

              <section class="statistics-detail__block">
                <h3>
                  {{ 'statistics.detail.whereaboutsTitle' | transloco }}
                  <span class="statistics-detail__subtitle">
                    {{ 'statistics.detail.whereaboutsSubtitle' | transloco }}
                  </span>
                </h3>

                <div class="statistics-detail__group-label statistics-detail__group-label--departure">
                  {{ 'statistics.detail.departureGroup' | transloco }}
                </div>
                <ng-container
                  [ngTemplateOutlet]="distribution"
                  [ngTemplateOutletContext]="{items: detail.departures, modifier: 'departure'}">
                </ng-container>
                <div class="statistics-detail__sum">
                  <span>{{ 'statistics.detail.departureEvents' | transloco }}</span>
                  <strong>{{ detail.departureEvents | statCount }}</strong>
                </div>
                <p class="statistics-detail__note">{{ detail.departureNote }}</p>

                <div class="statistics-detail__group-label statistics-detail__group-label--stay">
                  {{ 'statistics.detail.stayGroup' | transloco }}
                </div>
                <ng-container
                  [ngTemplateOutlet]="distribution"
                  [ngTemplateOutletContext]="{items: detail.stays, modifier: 'stay'}">
                </ng-container>
                <p class="statistics-detail__note">{{ 'statistics.detail.stayNote' | transloco }}</p>
              </section>
            }
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="statistics-table__legend">
    <span><strong>0</strong> {{ 'statistics.table.legendZero' | transloco }}</span>
    <span><strong>–</strong> {{ 'statistics.table.legendMissing' | transloco }}</span>
    @if (hiddenEmptyCount > 0) {
      <span>{{ 'statistics.table.hiddenEmpty' | transloco: {count: hiddenEmptyCount} }}</span>
    }
  </div>
</div>

<ng-template #distribution let-items="items" let-modifier="modifier">
  <div class="statistics-distribution">
    @for (item of items; track item.label) {
      <div class="statistics-distribution__item">
        <span class="statistics-distribution__label" [class.statistics-table__zero]="item.count === 0">
          {{ item.label }}
        </span>
        <span class="statistics-distribution__track">
          <span
            class="statistics-distribution__bar"
            [class]="'statistics-distribution__bar--' + modifier"
            [style.width.%]="item.percent">
          </span>
        </span>
        <span class="statistics-distribution__count" [class.statistics-table__zero]="item.count === 0">
          {{ item.count | statCount }}
        </span>
      </div>
    }
  </div>
</ng-template>
